/** "Coverage by service period" table for the Labour Management demo screen - shows whether
 * each site can actually run today's services, per service period. */

import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Link,
} from '@mui/material';
import { useTranslation } from 'react-i18next';
import { CoverageRow } from '../types';
import { CoverageChip } from './StatusChip';

interface CoverageTableProps {
  rows: CoverageRow[];
  onSelectSite: (site: string) => void;
}

const CoverageTable = ({ rows, onSelectSite }: CoverageTableProps) => {
  const { t } = useTranslation('common');

  return (
    <TableContainer>
      <Table size="small">
        <TableHead>
          <TableRow>
            <TableCell>{t('labourManagementSite', 'Site')}</TableCell>
            <TableCell>{t('labourManagementBreakfast', 'Breakfast')}</TableCell>
            <TableCell>{t('labourManagementLunch', 'Lunch')}</TableCell>
            <TableCell>{t('labourManagementHospitality', 'Hospitality')}</TableCell>
            <TableCell>{t('labourManagementEvents', 'Events')}</TableCell>
            <TableCell>{t('labourManagementDinner', 'Dinner')}</TableCell>
            <TableCell>{t('labourManagementOverallStatus', 'Overall status')}</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {rows.length === 0 && (
            <TableRow><TableCell colSpan={7}>{t('labourManagementNoResults', 'No sites match the current filters.')}</TableCell></TableRow>
          )}
          {rows.map((row) => (
            <TableRow key={row.site}>
              <TableCell>
                <Link component="button"
                  onClick={() => onSelectSite(row.site)}
                  underline="hover">
                  {row.site}
                </Link>
              </TableCell>
              <TableCell><CoverageChip status={row.breakfast} /></TableCell>
              <TableCell><CoverageChip status={row.lunch} /></TableCell>
              <TableCell><CoverageChip status={row.hospitality} /></TableCell>
              <TableCell><CoverageChip status={row.events} /></TableCell>
              <TableCell><CoverageChip status={row.dinner} /></TableCell>
              <TableCell><CoverageChip status={row.overall} /></TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </TableContainer>
  );
};

export default CoverageTable;
